'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearableTextField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAccessibilityTextField = require('@bibliocommons/base-accessibility-text-field');

var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/ClearableTextField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClearableTextField = exports.ClearableTextField = function (_BcReactComponent) {
  _inherits(ClearableTextField, _BcReactComponent);

  function ClearableTextField(props) {
    _classCallCheck(this, ClearableTextField);

    var _this = _possibleConstructorReturn(this, (ClearableTextField.__proto__ || Object.getPrototypeOf(ClearableTextField)).call(this, props));

    _this.bindAll('handleClear', 'renderClearButton');
    return _this;
  }

  _createClass(ClearableTextField, [{
    key: 'handleClear',
    value: function handleClear() {
      this.props.handleClear();
      if (this._textField) {
        this._textField.getWrappedInstance().focus();
      }
    }
  }, {
    key: 'renderClearButtonScreenReaderText',
    value: function renderClearButtonScreenReaderText() {
      if (this.props.clearButtonSrText) {
        return _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          this.props.clearButtonSrText
        );
      }

      return _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'ada_label_clear_text' },
        function (message) {
          return _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            message
          );
        }
      );
    }
  }, {
    key: 'renderClearButton',
    value: function renderClearButton() {
      if (!this.props.hideClearButton) {
        return _react2.default.createElement(
          _baseButtons.TextButton,
          {
            className: 'clear-icon',
            handleClick: this.handleClear,
            type: 'button' },
          _react2.default.createElement(_baseIcons.Cross, null),
          this.renderClearButtonScreenReaderText()
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-clearable-text-field' },
        _react2.default.createElement(_baseAccessibilityTextField2.default, {
          id: this.props.id,
          value: this.props.value,
          type: this.props.type,
          labelledById: this.props.labelledById,
          describedById: this.props.describedById,
          fieldErrors: this.props.fieldErrors,
          errorKey: this.props.errorKey,
          handleChange: this.props.handleChange,
          placeholder: this.props.placeholder,
          maxLength: this.props.maxLength,
          focus: this.props.focus,
          testId: this.props.inputTestId,
          info: this.props.info,
          inputIcon: this.renderClearButton(),
          className: this.props.className,
          characterCountSrOnly: this.props.characterCountSrOnly,
          ref: function ref(el) {
            return _this2._textField = el;
          } })
      );
    }
  }]);

  return ClearableTextField;
}(_baseBcReactComponent2.default);

ClearableTextField.propTypes = {
  id: _react.PropTypes.string,
  value: _react.PropTypes.string,
  hideClearButton: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  describedById: _react.PropTypes.string,
  fieldErrors: _react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape),
  errorKey: _react.PropTypes.string,
  labelledById: _react.PropTypes.string.isRequired,
  focus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  maxLength: _react.PropTypes.number,
  type: _react.PropTypes.string,
  inputTestId: _react.PropTypes.string,
  characterCountSrOnly: _react.PropTypes.bool,
  info: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),

  handleChange: _react.PropTypes.func,
  handleClear: _react.PropTypes.func
};

ClearableTextField.defaultProps = {
  hideClearButton: false
};

exports.default = ClearableTextField;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-clearable-text-field/lib/components/ClearableTextField.component.js
// module id = 1181
// module chunks = 0